import type { EnumOf } from '@packages/primitives/enum';

export const ServiceModes = {
  HTTP: 'http',
  FAKE: 'fake',
} as const;

export type ServiceMode = EnumOf<typeof ServiceModes>;

const DEFAULT_SERVICE_MODE = ServiceModes.HTTP;

export function resolveServiceMode(modeFromEnv: string | undefined): ServiceMode {
  switch (modeFromEnv) {
    case ServiceModes.HTTP:
      return ServiceModes.HTTP;
    case ServiceModes.FAKE:
      return ServiceModes.FAKE;
    default:
      return DEFAULT_SERVICE_MODE;
  }
}
